import LegalDocView from '../components/LegalDocView'
import { useSeoHead } from '../lib/seo'

export default function PrivacyPage() {
  useSeoHead({
    title: 'Zásady ochrany osobních údajů | SEO Tools',
    description: 'Jak SEO Tools zpracovává a chrání vaše osobní údaje — rozsah, účel, doba uchování a vaše práva podle GDPR.',
    canonicalPath: '/zasady-ochrany-osobnich-udaju',
  })
  return <LegalDocView doc="privacy" />
}
